import type { ReactNode } from 'react'
import { ClientTabFocusContext } from './clientTabFocusContext'
import { ClientTabRequirementsContext } from './clientTabRequirementsContext'
import useClientTabFocusProvider from './useClientTabFocusProvider'
import useClientTabRequirements from './useClientTabRequirements'

interface ClientTabStatusContextsProps {
  children: ReactNode
}

const ClientTabStatusContexts = ({ children }: ClientTabStatusContextsProps) => {
  const focus = useClientTabFocusProvider()
  const requirements = useClientTabRequirements()

  return (
    <ClientTabFocusContext.Provider value={focus}>
      <ClientTabRequirementsContext.Provider value={requirements}>{children}</ClientTabRequirementsContext.Provider>
    </ClientTabFocusContext.Provider>
  )
}

export default ClientTabStatusContexts
